export default "__VITE_ASSET__aR2MB3xc__"